export const baseStrapiGetSlugQueryObjectFromRoute = (queryParams: object = {}) => {
  const { params, query } = useRoute()
  const { slug } = params
  const { id } = params
  const { publicationState } = query
  const i18nActiveIso = baseI18nGetActiveIso()

  const object: QueryBySlugOptions = { ...queryParams, slug, id, publicationState, locale: i18nActiveIso }
  return object
}
